import { Component, OnInit, Input } from '@angular/core';
import { LFDynamicWidgetConfig } from '../../../models/lf-dynamic-widget-config';
import { FormPageConfig } from '../../../models/form-page-config';
import { DetailedEntityDataService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { DetailedEntityButtonService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-button.service';
import { SearchService } from '../../../search/search.service';
import { AbstractFormWidgetComponent } from '../../widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../core/navigation.service';
import { LeftPanelService } from '../../../../layout/home/services/left-panel.service';
import { UserService } from '../../../../core/security/user.service';
import { AlertService } from 'sce-core';
import { DatePickerConfigService } from '../../datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-commodity-widget-layout',
  templateUrl: './commodity-widget-layout.component.html',
  styleUrls: ['./commodity-widget-layout.component.css']
})
export class CommodityWidgetLayoutComponent extends AbstractFormWidgetComponent implements OnInit {

  @Input() public pageConfig: FormPageConfig;
  @Input() public widgetList: Array<LFDynamicWidgetConfig>;

  public primaryWidgetList: Array<LFDynamicWidgetConfig> = [];
  public detailWidget: LFDynamicWidgetConfig;
  public dataService: DetailedEntityDataService;
  public buttonService: DetailedEntityButtonService;
  public detailsSearchService: SearchService;
  public metadataMap: any ;
  public cellDataMap: any ;
  public accordionLine1: Array<any> = ['storerKey', 'sku', 'facility', 'descr'];
  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
    }

  public ngOnInit() {
    this.metadataMap = this.pageConfig.metaDataMap;
    this.cellDataMap = this.pageConfig.cellDataMap;
    this.dataService = <DetailedEntityDataService>this.pageConfig.dataService;
    this.detailsSearchService = this.dataService.detailsSearchService;
    this.buttonService = <DetailedEntityButtonService>this.pageConfig.buttonService;
    this.initializeWidgets();
  }

  // split the widgets into primary and detail widgets
  private initializeWidgets() {
    this.widgetList.forEach(widget => {
      widget.isOpen = true;
      if (widget.id === 'Details') {
        this.detailWidget = widget;
      } else {
        this.primaryWidgetList.push(widget);
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/layout/commodity-widget-layout/commodity-widget-layout.component.ts